import React from "react";
import { DateRangeOutlined, ExpandLess, ExpandMore } from "@mui/icons-material";
import { Badge, Collapse, ListItem, ListItemText, ListItemIcon, useTheme, SxProps } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import FilterListTooltip from "../FilterListTooltip";

export interface FilterListItemProps {
  title: string;
  secondary?: string;
  tooltip?: string;
  selected: number | string;
  icon?: any;
  open?: boolean;
  setOpen: (open: boolean) => void;
  children?: React.ReactNode;
  sx?: SxProps;
  noWrap?: boolean;
}

const FilterListItem: React.FC<FilterListItemProps> = ({
  title,
  secondary,
  tooltip = "",
  selected = 0,
  icon = 0,
  open,
  children,
  setOpen,
  sx = {},
  noWrap = false,
}) => {
  const theme = useTheme();
  const useListItemStyles = makeStyles(() => ({
    root: {
      paddingTop: "4px !important",
      paddingBottom: "4px !important",
      backgroundColor: "rgba(255, 255, 255, 0.05)",
    },
    divider: {
      borderBottomColor: "rgba(255, 255, 255, 0.15)",
    },
  }));

  const useCollapseStyles = makeStyles(() => ({
    wrapperInner: {
      padding: theme.spacing(4),
    },
  }));

  const useBadgeStyles = makeStyles(() => ({
    root: {
      paddingLeft: theme.spacing(0),
      paddingRight: theme.spacing(0),
      marginRight: theme.spacing(7),
      //minWidth: "20px !important",
      minWidth: noWrap ? "40px !important" : "70px !important",
      display: "flex",
      left: "-15px",
      position: "relative",
    },
    badge: {},
  }));

  const useIconStyles = makeStyles(() => ({
    root: {
      minWidth: 32,
      opacity: 0.75,
    },
  }));
  const listItemStyles = useListItemStyles();
  const badgeStyles = useBadgeStyles();
  const iconStyles = useIconStyles();
  const collapseStyles = useCollapseStyles();

  if (noWrap) {
    //sx = { ...sx, minWidth: "fit-content" };
  }
  return (
    <>
      <ListItem divider classes={listItemStyles} onClick={() => setOpen(!open)} title={tooltip} sx={sx}>
        {tooltip && <FilterListTooltip title={tooltip} />}
        <ListItemIcon classes={iconStyles}>{icon || <DateRangeOutlined fontSize="small" />}</ListItemIcon>
        <ListItemText primary={title} secondary={secondary} />
        <Badge classes={badgeStyles} badgeContent={selected} color="primary" />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse classes={collapseStyles} in={open} sx={sx}>
        {children}
      </Collapse>
    </>
  );
};

export default FilterListItem;
